import { UsdValue } from 'components/UsdValue';
import { Tiny1 } from 'components/Typography';
import { toNumber } from 'lodash';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { formatValueToSixDecimals } from '@dapp/multi-lib/lib/formatters';

interface VaultPriceProps {
  price: number;
  size?: 'xsmall' | 'small';
  performance: string;
  showPerformance?: boolean;
  className?: string;
  format?: Intl.NumberFormatOptions;
}

export const VaultPrice = (props: VaultPriceProps) => {
  const {
    price,
    performance,
    showPerformance,
    size = 'small',
    className,
    format = { minimumFractionDigits: 2, maximumFractionDigits: 6 },
  } = props;

  const isPositivePerformance = toNumber(performance.replace('%', '')) > 0;

  return (
    <div className={twMerge('flex flex-col items-end', className)}>
      <UsdValue size={size} value={price} format={format} />
      {showPerformance && (
        <Tiny1
          className={cx(
            twMerge(
              'font-normal',
              isPositivePerformance ? 'text-green' : 'text-red-500'
            )
          )}
        >
          {formatValueToSixDecimals(toNumber(performance.replace('%', '')))}%
        </Tiny1>
      )}
    </div>
  );
};
